export type TaskTimingActionsProps = {
  onToday?: () => void;
  onNow?: () => void;
  onClear?: () => void;
  color?: string;
};

export default function TaskTimingActions({ onToday, onNow, onClear, color }: TaskTimingActionsProps) {
  if (!onToday && !onNow && !onClear) return null;

  return (
    <div className="timing-actions">
      {onToday && <Action label="Today" onClick={onToday} color={color} />}
      {onNow && <Action label="Now" onClick={onNow} color={color} />}
      {onClear && <Action label="Clear" onClick={onClear} color={color} />}
    </div>
  );
}

function Action({ label, onClick, color }: { label: string; onClick: () => void; color?: string }) {
  return (
    <button type="button" onClick={onClick} className="action" style={{ color }}>
      {label}
    </button>
  );
}
